import React from "react";

import { cn } from "../../../common/u1/cn";
import { LockIcon } from "../../../../assets/ui/icons";

/* One of the three (sometimes four) ways to give TREVEX your figures. */
export const FinancialMethodCard = ({
  method,
  Icon,
  selected = false,
  locked = false,
  lockedReason,
  onSelect,
}) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={locked}
    aria-pressed={selected}
    className={cn(
      "flex w-full flex-col items-start rounded-[12px] border bg-white p-4 text-left",
      "transition-[border-color,box-shadow] duration-150",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)]",
      "focus-visible:ring-offset-2",
      locked
        ? "cursor-not-allowed border-[var(--line)] opacity-70"
        : selected
        ? "border-[var(--coral)] shadow-[0_0_0_1px_var(--coral)]"
        : "border-[var(--line)] hover:border-[var(--field-border-hover)]"
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        "flex h-10 w-10 items-center justify-center rounded-[10px]",
        locked
          ? "bg-[var(--slate-2)] text-[var(--muted)]"
          : "bg-[var(--coral-soft)] text-[var(--coral)]"
      )}
    >
      {locked ? <LockIcon size={16} /> : Icon ? <Icon size={17} /> : null}
    </span>

    <span className="mt-3 block text-[14px] font-bold text-[var(--ink)] font-sans">
      {method.title}
    </span>
    <span className="mt-1 block text-[12.5px] leading-[1.5] text-[var(--muted)] font-sans">
      {locked ? lockedReason : method.description}
    </span>
  </button>
);

export default FinancialMethodCard;
